module.exports = __webpack_public_path__ + "img/Project_Spectrum_Mission.4afb7a7a.png";